import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Img from 'react-image'
import { Icon, Loader, Button } from 'semantic-ui-react'

import { ProductCellContainer} from './styled'
import { productDetailPath } from '../..'
import noPreviewImage from 'assets/images/box.svg'
import { currencyNumberFormat, discountCalculator } from 'core/utilities'
import { StatusTag } from 'components'

const ProductCell = (props) => {

  const { product, onWishlistClick, wishlist } = props

  const addColumnEmpty = ()=>{
    let a = []
    if(product.length<6){
      for (let i = 0; i < 6-product.length; i++) {
        a[i] = <div key={i} style={{flex:1,marginRight:'0.3em',padding:10}}></div>
      }
    }
    return a
  }

  const getStatusCodeStyle = (status) => {
    return status === 'Published' ? 4 : 0
  }

  return (
    <ProductCellContainer>
      {product.map((item,i)=> (
        <div key={`products-${i}`} className='ProductCellCard'>
          <Link to={productDetailPath(item.id)}>
            <div style={{display:'flex',justifyContent:'center',height:'9em',alignItems:'center'}}>
              <Img
                style={{ opacity: item.coverImageUrl ? '' : '0.4'}}
                width='100' height='100'
                src={[item.coverImageUrl, noPreviewImage]}
                loader={<Loader>Loading</Loader>}
                unloader={<Icon color='grey' size='huge' name='image'/>}
              />
            </div>
            <div style={{display:'flex',flexDirection:'column',marginTop:'0.5em'}}>
              <p style={{fontWeight:'bold'}}>
                {item.productName}
              </p>
              <div style={{marginTop:'0.5em'}}>
                <p>{item.productCode}</p>
                <p>{item.brand}</p>
                <p>{item.productModel}</p>
                <div>
                  {
                    item.discount > 0 
                      ? <span style={{textDecoration: 'line-through', marginRight: '4px'}}>{currencyNumberFormat(item.price, item.currencyCode, 2)}</span>
                      : ''
                  }
                  <span>{`${currencyNumberFormat(discountCalculator(item.price, item.discount, item.discountType), item.currencyCode, 2)}`}</span>
                </div>
                <StatusTag status={getStatusCodeStyle(item.status)} statusName={item.status}>
                  {item.status}
                </StatusTag>
                
              </div>
            </div>
          </Link>
          <Button 
            icon 
            labelPosition='left' 
            size='mini' 
            style={{marginTop: '20px'}} 
            onClick={() => onWishlistClick(item)}
            disabled={wishlist.some(p => p.id === item.id)}
          >
            <Icon name='star' />
            Add to wishlist
          </Button>
        </div>
      ))}
      {addColumnEmpty().map((item)=>(
        item
      ))}
    </ProductCellContainer>
  )
}

const mapStateToProps = (state) => ({
  wishlist: state.product.wishlist,
})

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductCell)